export default "__VITE_ASSET__C5UuX1Kz__"